module.exports = __webpack_public_path__ + "img/h4.4e425899.png";